var _path, _path2, _path3, _path4, _line, _line2, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorShoes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m31.358,33.743c-4.287-1.072-7.383-3.334-10.242-12.028-1.383-4.208-1.427-11.76-1.104-18.437-4.3-.928-9.078-.47-13.59.628,1.354,6.195,2.904,11.94,2.904,14.356,0,4.287-2.441,7.503-2.441,20.364h6.848v-5.716c0-2.739,8.336,6.312,14.172,6.312s6.669-.476,7.383-1.072c.715-.595.357-3.334-3.93-4.406Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7.386,29.586c3.131.466,8.318,3.489,8.318,3.489"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12.083,2.93c1.329,10.516,3.561,22.454,2.312,29.424"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m8.299,11.062c4.381-.782,11.549.326,11.549.326"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.733,
    y1: 35.177,
    x2: 7.386,
    y2: 33.992
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 13.733,
    y1: 37.542,
    x2: 7.386,
    y2: 36.357
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m30.041,39.221c-11.175,0-12.971-6.147-16.309-6.312l-6.347-1.185"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorShoes);
export default __webpack_public_path__ + "static/media/indoor-shoes.693df9603c11805fe48d2d49416a159d.svg";
export { ForwardRef as ReactComponent };